import Tabby from 'tabbyjs';

if ( document.querySelector( '.tabs' ) !== null ) {
	const tabs = new Tabby( '.tabs', {
		default: window.innerWidth >= 840 ? '.tabs li:nth-child(2) a' : '.tabs li:first-child a'
	} );

	window.addEventListener( 'resize', function() {
		const description = document.querySelector( '#description' );

		if ( window.innerWidth >= 840 ) {
			if ( ! description.hasAttribute( 'hidden' ) ) {
				tabs.toggle( '#floorplan' );
				description.setAttribute( 'hidden', true );
			}
		} else {
			tabs.toggle( '#description' );
		}
	} );
}
